import { formatDropdownTimespan } from '@/app/common/dateHelper'
import { getBreaksMappingDestinationName } from '@/app/common/converters/configuration/breaksMappingDestinationToTextConverter'
import { getBreaksMappingDestination } from '@/app/services/configuration/breaksMappingDestinationResolver'
import { getTimesheetMinimalPeriodsSourceName } from '@/app/common/converters/configuration/timesheetMinimalPeriodsSourceToTextConverter'
import { getTimesheetMinimalPeriodsSource } from '@/app/services/configuration/timesheetMinimalPeriodsSourceResolver'
import { getShortBreakModeName } from '@/app/common/converters/configuration/shortBreakModeToTextConverter'
import { getShortBreakMode } from '@/app/services/configuration/shortBreakModeResolver'
import { getShortBreakTypeName } from '@/app/common/converters/configuration/shortBreakTypeToTextConverter'
import { getShortBreakType } from '@/app/services/configuration/shortBreakTypeResolver'
import { getLumpSumAmountsCoveredOptionsName } from '@/app/common/converters/configuration/lumpSumAmountsCoveredOptionsToTextConverter'
import { getLumpSumAmountsCoveredOptions } from '@/app/services/configuration/lumpSumAmountsCoveredOptionsResolver'
import type { TimesheetSettingFormatter } from '../timesheet-basic/formatters'

export const buildTimesheetAdditionalFormatters = (
  t: (key: string) => string,
): Record<string, TimesheetSettingFormatter> => ({
  breaksMapping: (v) =>
    getBreaksMappingDestinationName(getBreaksMappingDestination(v as number), t),
  timesheetMinimalPeriods: (v) =>
    getTimesheetMinimalPeriodsSourceName(
      getTimesheetMinimalPeriodsSource(v as number),
      t,
    ),
  shortBreakType: (v) =>
    getShortBreakTypeName(getShortBreakType(v as number), t),
  shortBreakMode: (v) =>
    getShortBreakModeName(getShortBreakMode(v as number), t),
  showAmountsCoveredByLumpsum: (v) =>
    getLumpSumAmountsCoveredOptionsName(
      getLumpSumAmountsCoveredOptions(v as number),
      t,
    ),
  plannedHoursRounding: (v) => formatDropdownTimespan(String(v), t),
  calculationRounding: (v) => formatDropdownTimespan(String(v), t),
})
